import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  ContractTypeListRequest,
  ContractTypeListResponse,
  ContractType,
  ContractTypeCreateRequest,
  ContractTypeUpdateRequest,
  ContractTypeShortListResponse,
} from "./types";

/**
 * List
 */
export const contractTypeListService = (params: ContractTypeListRequest) =>
  RestAPIClient.call<ContractTypeListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const contractTypeListShortService = (params: ContractTypeListRequest) =>
  RestAPIClient.call<ContractTypeShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const contractTypeDetailService = (id: number) =>
  RestAPIClient.call<ContractType>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const contractTypeCreateService = (data: ContractTypeCreateRequest) =>
  RestAPIClient.call<ContractType>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const contractTypeUpdateService = (data: ContractTypeUpdateRequest) =>
  RestAPIClient.call<ContractType>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
